export default __webpack_public_path__ + "static/media/avatar_12.53f0a062.png";